module.exports = {
  i18n: {
    locales: ['ro', 'en'],
    defaultLocale: 'ro',
    localeDetection: false,
  },
  trailingSlash: true,
};
